module.exports = __webpack_public_path__ + "static/media/root_logo.4fe41b9a.png";